export default {
  // Header
  header: {
    activities: '最新活动',
    products: '产品',
    solutions: '解决方案',
    partners: '合作伙伴',
    aboutUs: '关于我们',
    login: '登录',
    register: '免费注册',
    search: '搜索产品、文档...',
    registerBenefits: '注册即可获得福利：',
    benefit1: '30+产品免费试用',
    benefit2: '新用户专属优惠',
    benefit3: '优先体验新产品',
    signUpFree: '免费注册'
  },
  
  // Search
  search: {
    quickAccess: '快速访问',
    hotProducts: '热门产品',
    hkServer: '香港服务器',
    cloudServer: '云服务器',
    ddosProtection: 'DDoS防护',
    sslCertificate: 'SSL证书',
    bgpServer: 'BGP服务器',
    colocation: '服务器托管',
    multiIpServer: '站群服务器'
  },
  
  // Footer
  footer: {
    support247: '24/7',
    premiumSupport: '专业支持',
    newUser: '新用户',
    freeTrials: '免费试用',
    alwaysOn: '全天候',
    expertGuidance: '专家指导',
    reliable: '可靠',
    uptime: '99.95% 在线率',
    
    companyIntro: '公司介绍',
    aboutUs: '关于我们',
    joinUs: '加入我们',
    industryNews: '行业资讯',
    
    support: '支持',
    contactSales: '联系销售',
    openTicket: '开通工单',
    tickets: '工单',
    searchDownloads: '下载中心',
    knowledgebase: '知识库',
    announcements: '公告',
    networkStatus: '网络状态',
    
    billing: '账单',
    invoices: '发票',
    quotes: '报价',
    paymentMethod: '付款方式',
    addFunds: '充值',
    viewCart: '购物车',
    
    accountOverview: '账户概览',
    manageAccount: '管理账户',
    userManagement: '用户管理',
    accountSecurity: '账户安全',
    
    hotline: '24小时热线',
    companyName: 'Nebula Global LLC',
    companyAddress: '1359 S DREXEL WAY LAKEWOOD CO 80232 US',
    // companyEmail 已移至 /config.js
    companyPhone: '+1(970)516-9999',
    companyDesc: 'SCGIDC: 优质云解决方案。愿景：打造可信赖、高性价比的云品牌。',
    
    copyright: 'Copyright © 2024-2026 Nebula Global LLC. 保留所有权利。',
    termsOfService: '服务条款',
    privacyPolicy: '隐私政策',
    acceptableUsePolicy: '使用规范',
    dsaPolicy: 'DSA政策',
    dmcaPolicy: 'DMCA政策'
  },
  
  // Home
  home: {
    // Banner 1
    banner1Tag1: '超低延迟',
    banner1Tag2: '中港直连',
    banner1Title: '香港服务器：优惠特惠',
    banner1MainDesc: '强劲性能，极致网络',
    banner1SubDesc: '站群 \u00b7 优质IP | 高带宽 \u00b7 新上线',
    // Banner 2
    banner2Tag1: '成熟架构',
    banner2Tag2: 'CN2直连',
    banner2Title: '日本云服务器：扩容升级',
    banner2MainDesc: '资源池扩容 \u00b7 全新体验',
    // Banner 3
    banner3Tag1: '高防护',
    banner3Tag2: '支持压测',
    banner3Title: '香港高防IP升级',
    banner3MainDesc: '高防护 \u00b7 快速接入',
    banner3SubDesc: '200G真实防御，3分钟接入，弹性防护',
    // Slide tabs
    bannerTitle1: '香港服务器',
    bannerDesc1: '超低延迟，优惠价格',
    bannerTitle2: '日本云',
    bannerDesc2: '资源池扩容',
    bannerTitle3: '高防IP',
    bannerDesc3: '200G真实防御，快速开通',
    
    globalPartners: '全球顶级网络合作伙伴',
    hotProducts: '高速免备案产品',
    hotProductsDesc: '14年经验，10万+客户',
    featured: '精选',
    cloudServers: '云服务器',
    physicalServers: '物理服务器',
    antiDdos: '高防服务',
    
    buyNow: '立即购买',
    details: '查看详情',
    viewDetails: '查看详情',
    consultNow: '立即咨询',
    productDetails: '产品详情',
    console: '控制台',
    contactUs: '联系我们',
    contactSales: '联系销售',
    
    expert1v1: '1对1专家',
    customSolutions: '定制解决方案',
    freeMigration: '免费迁移指南',
    insiderDeals: '内部优惠',
    expertSupport: '专家支持',
    customProtection: '定制防护',
    alwaysAvailable: '全天候服务',
    budgetFriendly: '性价比高',
    enterpriseGrade: '企业级',
    instantSetup: '即时开通',
    
    // Product cards
    cloudServer: '云服务器',
    physicalServer: '物理服务器',
    antiDdosServer: '高防服务器',
    antiDdosIp: '高防IP',
    antiDdosCloud: '高防云',
    hkCloudServer: '香港云服务器',
    jpCloudServer: '日本云服务器',
    usCloudServer: '美国云服务器',
    hkAntiDdosCloud: '香港高防云',
    hkCloudIntl: '香港云(国际)',
    hkCloudOptimized: '香港云(优化)',
    hkServer: '香港服务器',
    jpServer: '日本服务器',
    hkHighBwServer: '香港高带宽服务器',
    hkMultiIpServer: '香港多IP服务器',
    usServer: '美国服务器',
    krServer: '韩国服务器',
    hkAntiDdosServer: '香港高防服务器',
    hkAntiDdosIp: '香港高防IP',
    usAntiDdos: '美国高防',
    
    // Product descriptions
    ddosProtection300G: '300G DDoS防护',
    ddosDefense200G: '200G防御3分钟接入',
    smartMitigation: '智能清洗',
    noIcpBestseller: '免备案爆款',
    multiLineOptions: '多线路可选',
    latencyToChina: '国内延迟60-120ms',
    cn2Gia: 'CN2 GIA',
    dedicatedBw: '延迟120-180ms，独享带宽',
    payByTraffic: '按流量计费',
    ddosProtected: '300G DDoS防护',
    globalBandwidth: '全球带宽',
    bw30MPlus: '30M+带宽',
    costEffective: '性价比高',
    bw10MPlus: '10M+带宽',
    clients100K: '10万+客户',
    freeIntranet: '免费内网',
    fastChinaAccess: '国内访问快',
    standard20M: '20M标准',
    optimizedBw300M: '300M优化带宽',
    rapidDeployment: '快速部署',
    bulkIpsAvailable: '可批量IP',
    cn2Optional30M: '30M CN2可选',
    freeDefense10G: '免费10G防御',
    premiumKtLgDc: '优质KT/LG机房',
    protection310G: '310G防护',
    testBeforeBuy: '先测试后购买',
    upgraded: '已升级',
    elasticDefense300G: '300G弹性防御',
    scaleOnDemand: '按需扩展',
    tier1Protection: '一级防护',
    protectedIps5: '5个防护IP',
    
    ddosExpertise14yr: '14年防御经验',
    shopNow: '立即购买',
    
    solutionsTitle: '经验丰富的场景解决方案',
    solutionsDesc: '为不同业务场景提供专业解决方案，提供多样化选择',
    retail: '零售',
    retailDesc: '全渠道营销、会员管理、客户终身价值。推动零售数字化。',
    automotive: '汽车',
    automotiveDesc: '个性化出行、深入用户互动。加速原厂数字化转型。',
    finance: '金融',
    financeDesc: '资产管理增长、智能风控、智慧网点。提升金融智能化。',
    cultureTourism: '文旅',
    cultureTourismDesc: '在线运营促增长，行业数字化。为政府、企业和游客提供指南。',
    internetPlus: '互联网+',
    internetPlusDesc: '一站式基础设施、数据、媒体和AI。助力业务增长。',
    contactSupport: '联系支持',
    
    announcements: '最新公告',
    announcementsDesc: '了解我们的最新动态',
    viewAll: '查看全部',
    
    perMonth: '/月',
    perYear: '/年',
    startingFrom: '起',
    
    // Features section
    featuresTitle: '14年港澳/海外服务器专家',
    featuresDesc: '14年全球服务器管理经验',
    
    feature1Title: '14年IDC老兵',
    feature1Desc: '企业ICT解决方案：全球托管、网络、容灾',
    feature1Link: '关于我们',
    
    feature2Title: '资源多样性',
    feature2Desc: 'APNIC/ARIN成员，拥有ASN，丰富IPv4/IPv6资源',
    feature2Link: '联系支持',
    
    feature3Title: '全球低延迟',
    feature3Desc: '港/美/日/韩直连CN2/CMI/联通，BGP冗余',
    feature3Link: '测试IP',
    
    feature4Title: 'Tier\u2162+数据中心',
    feature4Desc: '2N冗余，99.982%运行时间',
    feature4Link: '数据中心',
    
    feature5Title: '无需备案',
    feature5Desc: '即时部署：从云服务器到裸金属',
    feature5Link: '联系支持',
    
    feature6Title: '24/7现场支持',
    feature6Desc: 'CCIE团队驻场，快速响应故障',
    feature6Link: '提交工单',
    
    feature7Title: '年度硬件更新',
    feature7Desc: '防止硬件老化问题',
    feature7Link: '硬件定制',
    
    feature8Title: '数据隐私',
    feature8Desc: '客户数据完全自主',
    feature8Link: '隐私政策',
    
    feature9Title: '99.9%运行时间SLA',
    feature9Desc: '保证赔偿',
    feature9Link: 'SLA详情',
    
    feature10Title: '24/7优质支持',
    feature10Desc: '多渠道随时响应',
    feature10Link: '定制服务',
    
    // Solutions section
    retail: '零售',
    retailDesc: '全渠道营销、会员管理、客户终身价值。推动零售数字化。',
    automotive: '汽车',
    automotiveDesc: '个性化出行，更深用户参与。加速OEM数字化转型。',
    finance: '金融',
    financeDesc: 'AUM增长、智能风控、智慧网点。提升金融智能化。',
    cultureTourism: '文旅',
    cultureTourismDesc: '在线运营促增长，行业数字化。成为政府、企业、游客的向导。',
    internetPlus: '互联网+',
    internetPlusDesc: '一站式基础设施、数据、媒体与AI。助力业务增长。',
    contactSupport: '联系支持',
    
    // Region labels
    hkUsJp: '港/美/日',
    hkUs: '港/美',
    hongKong: '香港',
    
    // Tags
    tagHot: '热门',
    tagNew: '新品'
  },
  
  // Announcements
  announcements: {
    item1Title: '香港服务器扩容完成',
    item1Desc: '新的高性能节点现已上线，带宽容量增强',
    item2Title: '新年促销：七折优惠',
    item2Desc: '所有云服务器和专用主机计划限时优惠',
    item3Title: 'DDoS防护升级至300G',
    item3Desc: '增强的防护能力，更快的响应时间',
    item4Title: '日本数据中心上线',
    item4Desc: '亚太地区超低延迟连接',
    tagUpdate: '更新',
    tagPromo: '促销',
    tagNew: '新品',
    tagLaunch: '上线'
  },
  
  // Products Menu
  products: {
    allProducts: '全部产品',
    physicalServer: '物理服务器',
    cabinetRental: '机柜租赁',
    cloudServer: '云服务器',
    ddosProtection: 'DDoS防护',
    crossBuildingLinks: '楼内互联',
    multiIpServers: '站群服务器',
    sslCertificates: 'SSL证书',
    domains: '域名'
  },
  
  // Solutions Menu
  solutions: {
    service: '服务',
    serviceDesc: '专业服务解决方案',
    colocation: '服务器托管',
    colocationDesc: '专业服务器托管服务',
    bandwidth: '带宽',
    bandwidthDesc: '高速带宽解决方案',
    ipTransit: 'IP Transit',
    ipTransitDesc: '企业级IP传输解决方案，全球覆盖',
    crossCloud: '跨云连接',
    crossCloudDesc: '安全的多云网络连接',
    hybridCloud: '混合云',
    hybridCloudDesc: '公有云和私有云的无缝集成',
    dcInterconnect: '数据中心互联',
    dcInterconnectDesc: '高性能数据中心互联'
  },
  
  // Partners Menu
  partners: {
    partners: '合作伙伴',
    partnerWithUs: '与我们合作',
    joinProgram: '加入我们的合作伙伴计划',
    affiliateProgram: '推广联盟',
    affiliateDesc: '赚取15%佣金！$50奖励'
  },
  
  // About Menu (Header dropdown)
  aboutMenu: {
    infrastructure: '基础设施',
    expertise: '10+年香港/海外经验',
    companyIntro: '公司介绍',
    history: '发展历程',
    joinUs: '加入我们',
    contactUs: '联系我们'
  },
  
  // Server Products
  serverProducts: {
    hkBgpPremium: '香港BGP精品系列',
    hkBgpStandard: '香港BGP优品系列',
    hkBgpGlobal: '香港BGP国际',
    hkBgpAntiDdos: '香港BGP高防系列',
    hkBgpPremiumDesc: '直连全球最多的ISP路由，包含中国大陆地区',
    cloud: '云服务器',
    antiDdos: 'DDoS防护',
    hkColocation: '香港服务器托管',
    crossBuilding: '楼内线互联',
    siteCluster: '站群服务器',
    ssl: 'SSL证书'
  },
  
  // Common
  common: {
    learnMore: '了解更多',
    contactUs: '联系我们',
    month: '/月',
    year: '/年',
    hot: '热门',
    new: '新品',
    viewDetails: '查看详情',
    shopNow: '立即购买'
  },

  // About Page
  about: {
    aboutUs: '关于我们',
    companyName: 'Nebula Global LLC',
    companySlogan: '全球数据中心提供商，APNIC/ARIN成员，拥有ASN、IPv4/IPv6资源',
    clientArea: '用户中心',
    companyIntro: '公司介绍',
    joinUs: '加入我们',
    companyDesc: 'SCGIDC: 为开发者、政府、金融机构提供企业级云解决方案。',
    visionMission: '愿景与使命',
    vision: '愿景',
    visionText: '构建更美好的数字社会',
    mission: '使命',
    missionText: '让世界更高效',
    globalOffices: '全球办事处',
    singapore: '新加坡',
    hongKong: '香港',
    losAngeles: '洛杉矶',
    korea: '韩国',
    whyChooseUs: '为什么选择我们',
    feature1Title: '安全与可靠',
    feature1Desc: '多层安全防护和99.95% SLA保障',
    feature2Title: '全球网络',
    feature2Desc: '优质的全球主要区域网络连接',
    feature3Title: '24/7支持',
    feature3Desc: '全天候专家技术支持',
    followUs: '关注我们',
    socialDesc: '在社交媒体上关注我们，获取最新动态和资讯'
  },

  // Data Center Page
  datacenter: {
    title: '数据中心',
    globalDataCenters: '全球数据中心',
    subtitle: '企业级基础设施，提供99.99%正常运行时间SLA',
    explore: '探索数据中心',
    learnMore: '了解更多',
    features: '特性',
    specs: '规格',
    certifications: '认证',
    location: '位置',
    tier: '等级评级',
    power: '电力基础设施',
    cooling: '制冷系统',
    connectivity: '连接性',
    security: '安全',
    back: '返回列表',
    select: '选择数据中心',
    overview: '概览',
    network: '网络',
    securityCompliance: '安全与合规',
    allDataCenters: '所有数据中心',
    backToList: '返回列表',
    viewProducts: '查看产品',
    specifications: '规格参数',
    infrastructure: '基础设施',
    ourLocations: '我们的位置',
    locationsDesc: '点击位置了解更多数据中心设施信息',
    clientArea: '客户中心',
    centers: {
      'mega-i': {
        name: 'MEGA-i 香港数据中心',
        region: '香港',
        location: '香港柴湾',
        subtitle: '亚洲顶级互联枢纽 · 运营商密度最高的设施',
        advantageTitle: 'MEGA-i 竞争优势',
        infrastructureTitle: '军工级基础设施',
        notices: [
          { title: 'Tier III+ 认证设施', desc: '99.982%可用性，双路电源+24小时备电' },
          { title: '亚洲网络枢纽', desc: '直连9条海底光缆和300+运营商' },
          { title: '运营商中立环境', desc: '灵活选择运营商，支持AWS/Azure云连接' }
        ],
        descriptions: [
          '位于柴湾道399号的35万平方英尺旗舰设施 - 亚洲网络互联核心',
          '连接香港9/11条海底光缆：到东京<45ms，到新加坡<15ms，到洛杉矶<110ms',
          'HKCA“创新数据中心服务”获奖者，LEED金级认证(PUE≤1.5)'
        ],
        infrastructure: [
          { title: '电力系统', items: ['双路11kV电源(2000kVA变压器)', 'N+1冗余UPS(400kVA/层)+30分钟电池', '2000kVA柴油发电机(24/7连续供电)'] },
          { title: '制冷系统', items: ['精密制冷: 20℃±2℃, 50%±10%湿度', '冷水机组+直接膏胀双系统', '热通道封闭技术, PUE≤1.5'] },
          { title: '消防系统', items: ['VESDA吸气式烟雾探测', 'FM200洁净气体灭火系统'] },
          { title: '网络架构', items: ['15,000+交叉连接高速互联', '100mm钢管保护光纤主干'] },
          { title: '安全系统', items: ['双门互锁+生物识别门禁', '红外热成像监控+武装巡逻'] },
          { title: '运维支持', items: ['24/7现场工程支持', '15分钟故障响应SLA保证'] }
        ]
      },
      'chief': {
        name: '是方电讯立元数据中心',
        region: '香港',
        location: '香港葵涌',
        subtitle: '亚洲光缆枢纽 · 90%跨太平洋流量节点',
        advantageTitle: '东亚数字枢纽',
        infrastructureTitle: '军工级基础设施',
        notices: [
          { title: 'Tier III+ 认证设施', desc: '99.982%正常运行，双路11kV供电+72小时备电' },
          { title: '亚洲海底光缆枢纽', desc: '直连9条承载90%亚洲跨太平洋流量的光缆' },
          { title: '运营商中立环境', desc: '200+运营商，多路径BGP路由' }
        ],
        descriptions: [
          '位于台北阳光街6层专用IDC设施(10,000+平方米)',
          '连接TPIX/TPVX/TPCX交换中心: 到东京<15ms, 到新加坡<35ms',
          '中华电信子公司(ISO 27001/9001)，支持AWS/Azure直连'
        ],
        infrastructure: [
          { title: '电力系统', items: ['2N冗余UPS(总计18,000KVA)', '双路11kV供电+柴油备电(72小时)'] },
          { title: '制冷系统', items: ['N+1冗余冷水机(22±2℃)', '热通道封闭(PUE≤1.5)'] },
          { title: '消防系统', items: ['VESDA + FM200灭火系统'] },
          { title: '网络架构', items: ['BGP智能路由(CT/CU/CM/EDU)', '15,000+交叉连接，100Gbps互联'] },
          { title: '物理安全', items: ['生物识别+热成像+防尾随'] },
          { title: '运维支持', items: ['24/7现场工程师，15分钟响应SLA'] }
        ]
      },
      'globalswitch': {
        name: 'Global Switch 香港',
        region: '香港',
        location: '香港将军澳',
        subtitle: '世界级运营商中立设施 · 绿色能源认证',
        advantageTitle: 'Global Switch 优势',
        infrastructureTitle: '军工级基础设施',
        notices: [
          { title: '世界级基础设施', desc: '专建设施，2N+1冗余' },
          { title: '绿色能源认证', desc: 'LEED认证，行业领先PUE' },
          { title: '100+运营商连接', desc: '广泛的网络提供商生态' }
        ],
        descriptions: [
          '位于将军澳工业邨的高端数据中心园区',
          '多层安全防护，24/7现场人员',
          '直连主要云提供商和运营商'
        ],
        infrastructure: [
          { title: '电力系统', items: ['2N+1冗余电力架构', '多路市电+柴油备用'] },
          { title: '制冷系统', items: ['冷热通道封闭', '高效节能制冷系统'] },
          { title: '消防系统', items: ['VESDA早期预警探测', '气体灭火系统'] },
          { title: '网络', items: ['100+运营商选择', '云直连接入'] },
          { title: '安全', items: ['多层物理安全', '生物识别门禁'] },
          { title: '运维', items: ['24/7 NOC支持', '远程手服务'] }
        ]
      },
      'eq-sg1': {
        name: 'Equinix SG1 新加坡',
        region: '新加坡',
        location: '新加坡',
        subtitle: '东南亚门户 · 高端 IBX 数据中心',
        advantageTitle: 'Equinix 新加坡优势',
        infrastructureTitle: '企业级基础设施',
        notices: [
          { title: 'IBX 高端设施', desc: '行业领先的互联平台' },
          { title: '云直连', desc: 'AWS、Azure、Google Cloud直连' },
          { title: '丰富生态', desc: '500+网络和2,000+企业' }
        ],
        descriptions: [
          '位于东南亚金融中心的战略位置',
          'Equinix Fabric软件定义互联',
          '全面的合规认证'
        ],
        infrastructure: [
          { title: '电力系统', items: ['2N UPS + 柴油发电机', 'SLA保障的正常运行时间'] },
          { title: '制冷系统', items: ['冷水制冷', 'N+1冗余'] },
          { title: '消防系统', items: ['VESDA探测', '洁净气体灭火'] },
          { title: '网络', items: ['Equinix Fabric', '500+网络提供商'] },
          { title: '安全', items: ['双重门禁', '生物识别+门卡'] },
          { title: '运维', items: ['24/7智能手服务', '全球NOC支持'] }
        ]
      },
      'eq-ty8': {
        name: 'Equinix TY8 东京',
        region: '日本',
        location: '日本东京',
        subtitle: '亚太金融中心 · 超低延迟',
        advantageTitle: 'Equinix 东京优势',
        infrastructureTitle: '企业级基础设施',
        notices: [
          { title: '金融中心位置', desc: '直连东京证券交易所生态' },
          { title: '超低延迟', desc: '为高频交易优化' },
          { title: '灾难恢复', desc: '抗震隔离和备用电源' }
        ],
        descriptions: [
          '为金融服务和企业专门建造',
          '连接日本主要运营商和IX',
          '健全的灾害预防基础设施'
        ],
        infrastructure: [
          { title: '电力系统', items: ['2N并发可维护', '72小时燃料储备'] },
          { title: '制冷系统', items: ['N+1 CRAC单元', '冷热通道封闭'] },
          { title: '消防系统', items: ['VESDA + FM200'] },
          { title: '网络', items: ['200+网络提供商', '连接JPIX/JPNAP'] },
          { title: '安全', items: ['24/7安保人员', '多因素认证'] },
          { title: '运维', items: ['双语支持', '现场工程支持'] }
        ]
      },
      'coresite-la1': {
        name: 'CoreSite LA1 数据中心',
        region: '美国',
        location: '洛杉矶, CA',
        subtitle: '西海岸连接枢纽，直连亚太海底光缆',
        advantageTitle: 'CoreSite LA1 战略优势',
        infrastructureTitle: '核心基础设施',
        notices: [
          { title: '行业认证', desc: 'ISO 27001认证，24/7工程支持' },
          { title: '稳定供电', desc: 'N+1冗余UPS设计确保可靠性' },
          { title: '液冷设施', desc: '冷凝制冷提升能效' }
        ],
        descriptions: [
          '位于One Wilshire - 西海岸最关键的网络交换枢纽',
          '超过17.3万平方英尺设施，配备尖端基础设施',
          '适合高密度、计算密集型部署'
        ],
        infrastructure: [
          { title: '电力系统', items: ['N+1冗余UPS', '备用柴油发电机(72小时)', '多元化电源'] },
          { title: '制冷系统', items: ['N+1冷却塔和冷水机', '冷凝制冷', 'RFID环境监控'] },
          { title: '消防系统', items: ['VESDA早期烟雾探测', '双联锁预作用干式喷淋'] },
          { title: '网络架构', items: ['数百家运营商+暗光纤', 'AWS Direct Connect/Azure ExpressRoute'] },
          { title: '安全系统', items: ['生物识别+24/7安保人员'] },
          { title: '技术支持', items: ['24/7运维，100% SLA正常运行时间保证'] }
        ]
      },
      'west7': {
        name: 'West 7 洛杉矶地下设施',
        region: '美国',
        location: '洛杉矶, CA',
        subtitle: '全球最大地下数据枢纽 · 跨太平洋门户',
        advantageTitle: '西海岸数字堡垒',
        infrastructureTitle: '核心基础设施',
        notices: [
          { title: 'Tier III+ 地下堡垒', desc: '17.2万平方英尺，99.995%可用性' },
          { title: '17MW电力冗余', desc: '双电网+3000kVA UPS+72小时备电' },
          { title: '战略网络枢纽', desc: '直连6条跨太平洋光缆' }
        ],
        descriptions: [
          '深层岩石位置: 抗靉9级，7米防洪',
          'TPE/EAC-C2C光缆终端: 到东京<85ms，到上海<120ms',
          'ISO 27001/SSAE 18认证，30Pa正压容投'
        ],
        infrastructure: [
          { title: '电力系统', items: ['2N UPS(3000kVA)+18×2MVA变压器', '双路138kV馈电+72小时发电机'] },
          { title: '制冷系统', items: ['9,000吨水冷(PUE≤1.35)', '地热岩层制冷(±0.5℃稳定性)'] },
          { title: '消防系统', items: ['VESDA激光探测+氟代酮灭火'] },
          { title: '网络架构', items: ['12家一级运营商包括AT&T/Verizon', '100Gbps主干+BGP优化'] },
          { title: '物理安全', items: ['军用级生物识别+防尾随气闸', '防弹玻璃监控室+动态压力传感器'] },
          { title: '运维', items: ['24/7工程师，5分钟紧急SLA', '4小时硬件故障更换'] }
        ]
      },
      'tyo1': {
        name: 'DigitalEdge TYO1 东京数据中心',
        region: '日本',
        location: '东京文京区',
        subtitle: '文京核心 · Tier III认证 · 3.76MW高密度枢纽',
        advantageTitle: '东京数字枢纽中心',
        infrastructureTitle: '核心设施规格',
        notices: [
          { title: '金融级低延迟', desc: '连接8大交易所节点，HFT延迟<0.5ms' },
          { title: '全冗余基础设施', desc: 'N+1 UPS+三路供电，燃气轮机24小时备电' },
          { title: '东京黄金地段', desc: '距山手线5分钟，毗邻电信枢纽' }
        ],
        descriptions: [
          '2,470㎡托管空间，940个机柜，三重ISO认证',
          'Cross Link™低延迟连接TYO2/TYO3',
          'FSA指定合规设施，支持HFT和边缘计算'
        ],
        infrastructure: [
          { title: '电力系统', items: ['三路市电供应', 'N+1并联冗余UPS', '3×4,000kVA燃气轮机(24小时储备)'] },
          { title: '制冷系统', items: ['N+1地板下送风空调', 'PUE 1.5东京低碳合规', '每机柜4kVA功率密度'] },
          { title: '消防系统', items: ['VESDA吸气式探测', '惰性气体灭火'] },
          { title: '网络架构', items: ['3条独立光纤入口', '支持Cross Connect & Cross Link™互联'] },
          { title: '物理安全', items: ['生物识别+防尾随+24/7 SOC', '超越日本建筑标准的抗震设计'] },
          { title: '运维', items: ['24/365远程手服务', '100%双电路/99.99%单电路SLA'] }
        ]
      },
      'tgt': {
        name: 'TGT 香港数据中心',
        region: '香港',
        location: '香港将军澳',
        subtitle: '将军澳核心枢纽 · 战略海底光缆节点',
        advantageTitle: '亚洲核心数字枢纽',
        infrastructureTitle: '军工级基础设施',
        notices: [
          { title: 'TIA-942 Rated 3+ 认证', desc: '99.982%正常运行，双路电源+72小时备电' },
          { title: '海底光缆直连', desc: '到亚洲主要城市延迟<5ms' },
          { title: '燃气管道光纤技术', desc: 'GIG技术减少故障60%，抗震' }
        ],
        descriptions: [
          '位于将军澳工业邨22号 - 亚洲政府规划的数据中心枢纽',
          '5层、2.2万平方米设施，支持3,300个高密度机柜',
          '先进安全基础设施，适合跨境业务扩展'
        ],
        infrastructure: [
          { title: '电力系统', items: ['18,000KVA+2N冗余UPS+24×2MVA变压器', '双路11kV供电+柴油备用(72小时)'] },
          { title: '制冷系统', items: ['水冷+溴化锂吸收式(PUE≤1.5)', '热通道封闭±0.5℃稳定性'] },
          { title: '消防系统', items: ['VESDA + FM200洁净气体灭火'] },
          { title: '网络架构', items: ['7家一级运营商包括PCCW/HKBN', '双 POP+BGP多路径切换'] },
          { title: '物理安全', items: ['生物识别+热成像(ISO27001/9001)'] },
          { title: '运维', items: ['24/7工程师，15分钟响应SLA'] }
        ]
      },
      'global-switch-woolands': {
        name: 'Global Switch Woodlands 设施',
        region: '新加坡',
        location: '新加坡兆基',
        subtitle: '亚太绿色数字枢纽 · 30MW双活设计',
        advantageTitle: '东南亚数字枢纽',
        infrastructureTitle: '核心基础设施',
        notices: [
          { title: 'Tier III+ 认证设施', desc: '99.982%正常运行，双变电站+24小时备电' },
          { title: '新加坡能效标杆', desc: 'PUE 1.34，LEED金级+BCA铂金' },
          { title: '金融级安全', desc: 'MAS合规，防撞屏障+生物识别' }
        ],
        descriptions: [
          '7层兆基设施(2.5万平方米)，7,800机柜容量',
          '到大成设施<1ms光纤，300+运营商',
          '模块化预制(60% MEP工厂建造)'
        ],
        infrastructure: [
          { title: '电力系统', items: ['双变电站供电(30MVA)', '18台屋顶DRUPS(N+2)', '20万升燃料储存(24/7供电)'] },
          { title: '制冷系统', items: ['变频风机+高效CRAH', '3.5米净高支持58U机柜', '可重配置配电'] },
          { title: '消防系统', items: ['VESDA吸气式探测', 'FM200洁净气体灭火'] },
          { title: '网络架构', items: ['双光纤到MMR交换室', '5吨专用货梯'] },
          { title: '物理安全', items: ['防撞屏障+周界探测', '屋顶发电机保护系统'] },
          { title: '运维', items: ['24/7工程支持', '零停机迁移服务'] }
        ]
      }
    }
  },
  
  // Legal Pages
  legal: {
    legal: '法律',
    tableOfContents: '目录',
    lastUpdated: '最后更新',
    contactInfo: '如对这些政策有任何疑问，请通过邮件联系我们',
    otherPolicies: '其他政策',
    tosDesc: '我们的服务条款规定您使用我们服务的方式',
    privacyDesc: '我们的隐私政策解释我们如何收集、使用和保护您的个人信息',
    aupDesc: '我们的可接受使用政策概述了允许和禁止的服务使用方式',
    dsaDesc: '我们的数字服务法案政策符合欧盟法规',
    dmcaDesc: '我们的DMCA政策处理版权侵权索赔',
    
    tos: {
      section1Title: '引言',
      section1Content1: '欢迎来到Nebula Global LLC。这些服务条款管辖您对我们网站、服务和产品的使用。',
      section1Content2: '通过访问或使用我们的服务，您同意受这些条款和所有适用法律和法规的约束。',
      section2Title: '使用许可',
      section2Content1: '根据这些条款，我们授予您有限的、非独占的许可证，以访问和供个人使用我们的服务。',
      section2Content2: '此许可证不包括任何转售或商业使用我们的服务或相关内容。',
      section3Title: '用户账户',
      section3Sub1: '账户注册',
      section3Item1: '您必须提供准确完整的信息',
      section3Item2: '您必须维护和更新您的账户信息',
      section3Item3: '您有责任保护您的账户凭证',
      section3Item4: '您对账户下发生的所有活动负责',
      section3Sub2: '账户终止',
      section3Item5: '我们可以随时终止或暂停您的账户',
      section3Item6: '您可以随时关闭您的账户',
      section3Item7: '一旦终止，您使用服务的权利将停止',
      section4Title: '禁止使用',
      section4Sub1: '非法活动',
      section4Item1: '将我们的服务用于任何非法目的',
      section4Item2: '违反任何本地、州、国家或国际法律',
      section4Item3: '从事欺诈活动',
      section4Sub2: '系统滥用',
      section4Item4: '试图获得对我们系统的未授权访问',
      section4Item5: '引入病毒或恶意代码',
      section4Item6: '用过多请求超载我们的服务器',
      section5Title: '付款和计费',
      section5Item1: '所有服务均需预付款',
      section5Item2: '我们保留随时更改定价的权利',
      section5Sub1: '计费周期',
      section5Item3: '根据服务不同，计费按月或按年进行',
      section5Sub2: '付款方式',
      section5Item4: '我们接受信用卡、PayPal和银行转账',
      section5Item5: '逾期付款可能导致服务暂停',
      section6Title: '终止',
      section6Sub1: '由您终止',
      section6Item1: '您可以随时终止您的订阅',
      section6Item2: '某些服务可能有取消费用',
      section6Item3: '退款受我们的退款政策约束',
      section6Sub2: '由我们终止',
      section6Item4: '我们可能因违反条款而终止您的访问权限',
      section6Item5: '我们将在终止前提供通知',
      section7Title: '保修免责声明',
      section7Sub1: '服务可用性',
      section7Item1: '我们的服务按原样提供，不提供任何保证',
      section7Item2: '我们不保证服务可用性的不间断性'
    },
    
    privacy: {
      section1Title: '我们收集的信息',
      section1Content: '我们收集您直接提供给我们的信息，例如当您创建账户、使用我们的服务或与我们沟通时。',
      section2Title: '我们如何使用信息',
      section2Item1: '提供、维护和改进我们的服务',
      section2Item2: '处理交易并发送相关通信',
      section2Item3: '发送技术通知和支持消息',
      section2Item4: '防范欺诈和滥用',
      section3Title: '信息共享',
      section3Item1: '经您的同意',
      section3Item2: '与需要访问权限的供应商和服务提供商',
      section3Item3: '按法律或法律程序要求',
      section4Title: '数据安全',
      section4Content: '我们实施适当的技术和组织措施，以保护个人数据免遭未经授权的访问、更改、披露或销毁。',
      section5Title: '您的权利',
      section5Content: '根据您的位置，您可能有权访问、更正或删除您的个人信息。请联系我们行使这些权利。',
      section6Title: '联系我们',
      section6Content: '如果您对此隐私政策有任何疑问，请通过邮件联系我们。'
    },
    
    aup: {
      section1Title: '可接受使用',
      section1Content: '我们的服务只能用于合法目的，并遵守这些条款。您同意不将我们的服务用于发送垃圾邮件、分发恶意软件或从事任何有害活动。',
      section2Title: '禁止活动',
      section2Item1: '发送未经请求的批量电子邮件或垃圾邮件',
      section2Item2: '托管非法内容或从事非法活动',
      section2Item3: '分发恶意软件、病毒或其他有害软件',
      section2Item4: '试图侵犯安全或获得未授权访问',
      section2Item5: '超载系统或中断服务',
      section3Title: '执行',
      section3Content: '违反此AUP可能导致您的账户被暂停或终止。我们保留调查投诉并采取适当行动的权利。',
      section4Title: '报告违规行为',
      section4Content: '如果您意识到我们服务的任何滥用情况，请通过邮件报告。'
    },
    
    dsa: {
      section1Title: '应用范围',
      section1Content: '本政策适用于我们作为《数字服务法案》所定义的在线中介服务。我们致力于确保我们的服务符合欧盟法规。',
      section2Title: '通知和行动',
      section2Content: '我们已建立接收和处理非法内容或知识产权侵权通知的程序。',
      section3Title: '透明度报告',
      section3Content: '我们发布年度透明度报告，详细说明我们在DSA下的合规努力和执法行动。'
    },
    
    dmca: {
      section1Title: '版权政策',
      section1Content: '我们尊重他人的知识产权，并期望我们的服务用户也这样做。',
      section2Title: '版权侵权通知',
      section2Item1: '必须以书面形式并由版权所有者或授权代理人签名',
      section2Item2: '必须确定声称被侵犯的版权作品',
      section2Item3: '必须确定声称侵权的材料',
      section2Item4: '必须包括投诉方的联系信息',
      section2Item5: '必须包括诚信信念和准确性的声明',
      section3Title: '反通知',
      section3Content: '那些被移除内容的人可以提交挑战移除的反通知。',
      section4Title: '重复侵权者',
      section4Content: '在适当情况下，我们将终止重复侵权者的账户。'
    }
  },
  contact: {
    contactUs: '联系我们',
    contactDesc: '我们很乐意听取您的意见。<br>如有咨询、反馈或合作意向，请联系我们。',
    openTicket: '提交工单',
    phoneSupport: '电话支持',
    phoneDesc: 'VIP解决方案，24/7全天候服务',
    callNow: '立即拨打',
    supportTicket: '支持工单',
    email: '电子邮件',
    preSalesAfterSales: '售前与售后',
    channelTitle: '常见问题解答，帮助您快速入门',
    liveChat: '在线客服',
    liveChatDesc: '实时聊天，即时解答',
    hours: '服务时间',
    phoneSupportDesc: '快速响应，24/7全天候服务',
    ticketDesc: '提交工单，我们将尽快回复',
    priority: '优先',
    documentation: '文档中心',
    docDesc: '查看常见问题和教程',
    selfService: '自助服务',
    ourOffices: '我们的办事处',
    officeWelcome: '欢迎来访，我们竭诚为您服务',
    usHeadquarters: '美国总部',
    hongKongOffice: '香港',
    announcements: '公告',
    networkStatus: '网络状态',
    myTickets: '我的工单'
  },
  
  // Pages
  pages: {
    activity: {
      title: '最新活动',
      subtitle: '查看当前的优惠活动',
      metaDesc: '最新优惠活动，新用户专享福利'
    },
    products: {
      title: '产品与服务',
      subtitle: '查看我们的全部产品',
      metaDesc: '提供云服务器、物理服务器、SSL证书、域名注册等产品'
    },
    solutions: {
      title: '解决方案',
      subtitle: '专业的企业级解决方案',
      metaDesc: '提供混合云、跨云互联、带宽服务等企业级解决方案'
    },
    docs: {
      title: '文档中心',
      subtitle: '产品文档和使用教程',
      metaDesc: '产品文档、API文档和使用教程'
    },
    news: {
      title: '新闻公告',
      subtitle: '最新的新闻和公告信息',
      metaDesc: '最新新闻、公告和行业动态'
    },
    cloud: {
      title: '云服务器',
      subtitle: '弹性伸缩的云计算解决方案',
      metaDesc: '云服务器，弹性伸缩，按需付费，快速部署'
    },
    server: {
      title: '物理服务器',
      subtitle: '高性能独立服务器解决方案',
      metaDesc: '高性能物理服务器，专属资源保障'
    },
    ssl: {
      title: 'SSL证书',
      subtitle: '保护您的网站安全',
      metaDesc: 'SSL证书，快速签发，保护网站安全'
    },
    domain: {
      title: '域名注册',
      subtitle: '快速注册您的域名',
      metaDesc: '域名注册，多种后缀选择，价格优惠'
    }
  }
}
